import {Component, OnDestroy, OnInit} from '@angular/core';
import {NotifierService} from "./notifier.service";
import {Notification} from "./notification";
import {NotificationType} from "./notification-type.enum";
import {
  trigger,
  style,
  animate,
  transition,
  state
} from '@angular/animations';

@Component({
  selector: 'pbc-notifier',
  templateUrl: './notifier.component.html',
  animations: [
    trigger('flyInOut', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(300)
      ]),
      transition('* => void', [
        animate(300, style({ transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class NotifierComponent implements OnInit, OnDestroy {

  constructor(private notifierService: NotifierService) { }
  notifications = new Array<Notification>();
  private static CLOSE_NOTIFICATION_AFTER = 5000;
  private notificationTypes = NotificationType;

  ngOnInit() {
    this.notifierService.notification.subscribe(
      (notification: Notification)=>{
        this.notifications.splice(0, 0, notification);
        setTimeout(() => this.closeNotification(0), NotifierComponent.CLOSE_NOTIFICATION_AFTER);
      });
  }

  ngOnDestroy() {
    this.notifierService.notification.unsubscribe();
  }

  closeNotification(i: number) {
    this.notifications.splice(i,1);
  }
}
